(function () {
    'use strict';

    angular.module('gov.filters')
        .filter('numeral', numFilter);

    numFilter.$inject = [];

    function numFilter() {
        return function (input, format) {
            var formattedNum = numeral(input).format(format);
            return formattedNum;
        }
    }
})();